'use strict';

/* jshint -W098 */
angular.module('mean.projects').controller('ProjectTasksAdminController', ['$scope', '$rootScope', '$q', 'Global', 'Projects', 'ProjectBids', 'MeanUser', 'Users', '$filter', '$http', 'Holidays', '$timeout', 'ProjectTasks', 'taskFilterService', 'daysDifferenceService', 'taskRescheduleService', 'taskService', 'tradeCodeService', 'taskListService', 'userService', 'aceUtils',
  function($scope, $rootScope, $q, Global, Projects, ProjectBids, MeanUser, Users, $filter, $http, Holidays, $timeout, ProjectTasks, taskFilterService, daysDifferenceService, taskRescheduleService, taskService, tradeCodeService, taskListService, userService, aceUtils) {
    $scope.global = Global;
    $scope.package = {
      name: 'projectTasksAdmin'
    };

    $scope.mode = 'day';

    $scope.status_codes = ['on_track', 'delayed_start', 'work_stoppage', 'finished'];

    $scope.date_array = [];

    $scope.sortType = ['phase', 'lot', 'task_code'];
    $scope.sortReverse = false;

    $scope.tasks = [];
    $scope.projects = [];
    $scope.foreman_users = [];
    $scope.tradesman_users = [];
    $scope.my_roles = [];
    $scope.is_admin = false;
    $scope.is_builder = false;
    $scope.is_division = false;
    $scope.is_manager = false;
    $scope.selectedPhase = '';

    $scope.minDate = new Date();
    $scope.dateOptions = {
        dateDisabled: disabled,
        formatYear: 'yy',
        minDate: new Date(),
        maxDate: new Date(2030, 1, 20),
        showWeeks: false,
        startingDay: 0
    };

    $scope.user = MeanUser.user;
    $scope.my_roles = MeanUser.user.roles;

    daysDifferenceService.setHolidaysArray($scope.user.username);

    $scope.current_trades = tradeCodeService.getArray();

    $scope.formatString = 'yyyy-MM-ddTHH:mm';

    $scope.open = function($event) {
        $event.preventDefault();
        $event.stopPropagation();

        $scope.opened = true;
    };

    $scope.openEnd = function($event) {
        $event.preventDefault();
        $event.stopPropagation();

        $scope.endOpened = true;
    };

    $scope.editOpen = function($event) {
        $event.preventDefault();
        $event.stopPropagation();

        $timeout(function() {
            $scope.editOpened = true;
        }, 50);
    };

    taskListService.get().then(function(result) {
        console.log('query call is complete');
        $scope.current_tasks = result;
    });

    function disabled(data) {
        return daysDifferenceService.disabled(data.date, data.mode);
    };

    $scope.init = function() {
    	$scope.my_roles.forEach(function(role) {
    		if(role === 'admin') {
    			$scope.is_admin = true;
    		} else if(role === 'builder_admin') {
    			$scope.is_builder = true;
    		} else if(role === 'tm_admin') {
    			$scope.is_trade = true;
    		} else if (role === 'tm') {
			    $scope.is_manager = true;
			}
		});

		if($scope.is_admin) {
			//I want to see all the projects
			Projects.query({'complete': false}, function(projects) {
		    	$scope.projects = projects;
		    });
		} else if($scope.is_builder) {
			//I want to see all of my contracted projects
			Projects.query({'trade_code': userService.getTradeCode(MeanUser.user.username), 
                'complete': false,
                'company_code': userService.getCompanyCode(MeanUser.user.username)}, function(projects) {
		    	$scope.projects = projects;
		    });
		} else if($scope.is_division) {
			//I want to see all projects that i'm assigned to
			Projects.query({'trade_code': userService.getTradeCode(MeanUser.user.username), 
                'complete': false,
                'company_code': userService.getCompanyCode(MeanUser.user.username)}, function(projects) {
		    	$scope.projects = projects;
		    });
		} else if ($scope.is_manager) {
		    Projects.query({'trade_code': userService.getTradeCode(MeanUser.user.username), 
                'complete': false,
                'company_code': userService.getCompanyCode(MeanUser.user.username)}, function(projects) {
		    	$scope.projects = projects;
		    });
		}

		// if($scope.is_admin || $scope.is_builder || $scope.is_division) {
		// 	Users.query({ roles: 'foreman' }, function(users) {
	 //            $scope.foreman_users = $filter('filter')(users, { roles: 'foreman' });
	 //        });
		// } else if($scope.is_manager) {
		//     Users.query({ roles: 'foreman' }, function(users) {
	 //            $scope.foreman_users = $filter('filter')(users, { roles: 'foreman', trade: MeanUser.user.trade[0] });
	 //        });
		// } 
	};

	$scope.changeProject = function() {
		//console.log('changed project ' + $scope.selectedItem._id);
		$scope.tasks = [];
        $scope.formatString = $scope.formatString + $scope.selectedItem.contact.timezone;

        $scope.updatePhaseList();
        $scope.changePhase();
        $scope.changeTrade();

        //$scope.selectedTask = $scope.current_tasks[0];
        //console.log('Set the new timezone formate string: ' + $scope.formatString);

		/*if($scope.is_admin) {
			var q_call = ProjectTasks.query({ 'project_id': $scope.selectedItem._id}, function(tasks) {
				
			});
		} else if ($scope.is_builder || $scope.is_division) {
			var q_call = ProjectTasks.query({'project_id': $scope.selectedItem._id}, function(tasks) {
		    	
		    });
		} else if ($scope.is_manager) {
		    var q_call = ProjectTasks.query({'project_id': $scope.selectedItem._id, 'trade_manager_id': MeanUser.user._id}, function(tasks) {
		    	
		    });
		}*/

        // q_call.$promise.then(function(result) {
        //     console.log('query call is complete');
        //     $scope.tasks = result;
        //     $scope.updatePhaseList();
        //     $scope.changePhase();
        //     $scope.changeTrade();
        // });
	};

    $scope.changePhase = function(selectedPhase) {
        $scope.selectedPhase = selectedPhase;
        //console.log('$scope.changePhase called');

        $scope.lots = [];

        var lots = [];
        if(selectedPhase)
            lots = $filter('filter')($scope.selectedItem.lots, {'phase': selectedPhase.name}, true);
        else
            lots = $scope.selectedItem.lots

        lots.forEach(function(lot) {
            var inlist = $filter('filter')($scope.lots, {'name': lot.number}, true);

            if(inlist.length === 0) {
                $scope.lots.push({
                    name: lot.number
                });
            }
        });
    };

    $scope.changeLot = function(selectedLot) {
        $scope.selectedLot = selectedLot;
    };

    $scope.changeTrade = function(selectedTrade) {
        if(aceUtils.isUndefinedOrNull(selectedTrade)) {
            //$scope.selectedTrade = $scope.current_trades[0];
        } else {
            $scope.selectedTrade = selectedTrade;
        }
        // $scope.selectedTrade = selectedTrade;
        // console.log('$scope.changeTrade called');
        
        // var tasks = [];

        // tasks = taskFilterService.getList($scope.tasks,
        //             $scope.selectedTrade);
    };

    $scope.changeTask = function(selectedTask) {
        if(!aceUtils.isUndefinedOrNull(selectedTask))
          $scope.selectedTask.name = selectedTask.task_code;
        else 
          $scope.selectedTask = $scope.current_tasks[0];

        // $scope.selectedTask = {};

        // if(selectedTask)
        //   $scope.selectedTask.name = selectedTask.task_code;
    };

    $scope.updatePhaseList = function() {
        $scope.current_phases = [];

        $scope.selectedItem.lots.forEach(function(lot) {
            var inlist = $filter('filter')($scope.current_phases, {'name': lot.phase}, true);

            if(inlist.length === 0) {
                $scope.current_phases.push({
                    name: lot.phase
                });
            }
        });
    };

    $scope.getFilteredTasks = function() {
        $scope.guiRecordItem = ($scope.selectedItem) ? $scope.selectedItem.name : 'All';
        var trade = $scope.guiRecordTrade = ($scope.selectedTrade) ? $scope.selectedTrade.name : 'All';
        var task = $scope.guiRecordTask = ($scope.selectedTask) ? $scope.selectedTask.name : 'All';
        var phase = $scope.guiRecordPhase = ($scope.selectedPhase) ? $scope.selectedPhase.name : 'All';
        var lot = $scope.guiRecordLot = ($scope.selectedLot) ? $scope.selectedLot.name : 'All';

        if($scope.is_admin) {
            if(task !== 'All') {
                if(lot !== 'All') {
                    var q_call = ProjectTasks.query({ 
                        'project_id': $scope.selectedItem._id,
                        'trade': $scope.selectedTrade.name,
                        'complete': false,
                        'lot': $scope.selectedLot.name,
                        'task_code': $scope.selectedTask.name }, function(tasks) {
                    });
                } else if(phase !== 'All') {
                    var q_call = ProjectTasks.query({ 
                        'project_id': $scope.selectedItem._id,
                        'trade': $scope.selectedTrade.name,
                        'complete': false,
                        'phase': $scope.selectedPhase.name,
                        'task_code': $scope.selectedTask.name }, function(tasks) {
                    });
                } else if(trade !== 'All') {
                    var q_call = ProjectTasks.query({ 
                        'project_id': $scope.selectedItem._id,
                        'complete': false,
                        'trade': $scope.selectedTrade.name,
                        'task_code': $scope.selectedTask.name}, function(tasks) {
                    });
                } else {
                    var q_call = ProjectTasks.query({ 
                        'project_id': $scope.selectedItem._id,
                        'complete': false,
                        'task_code': $scope.selectedTask.name}, function(tasks) {
                    });
                }
            } else if(trade !== 'All') {
                if(lot !== 'All') {
                    var q_call = ProjectTasks.query({ 
                        'project_id': $scope.selectedItem._id,
                        'complete': false,
                        'trade': $scope.selectedTrade.name,
                        'lot': $scope.selectedLot.name }, function(tasks) {
                    });
                } else if(phase !== 'All') {
                    var q_call = ProjectTasks.query({ 
                        'project_id': $scope.selectedItem._id,
                        'complete': false,
                        'trade': $scope.selectedTrade.name,
                        'phase': $scope.selectedPhase.name }, function(tasks) {
                    });
                } else {
                    var q_call = ProjectTasks.query({ 
                        'project_id': $scope.selectedItem._id,
                        'complete': false,
                        'trade': $scope.selectedTrade.name}, function(tasks) {
                    });
                }
            } else if(lot !== 'All') {
                var q_call = ProjectTasks.query({ 
                    'project_id': $scope.selectedItem._id,
                    'complete': false,
                    'lot': $scope.selectedLot.name}, function(tasks) {
                });
            } else if(phase !== 'All') {
                var q_call = ProjectTasks.query({ 
                    'project_id': $scope.selectedItem._id,
                    'complete': false,
                    'phase': $scope.selectedPhase.name}, function(tasks) {
                });
            } else {
                var q_call = ProjectTasks.query({ 
                    'project_id': $scope.selectedItem._id,
                    'complete': false }, function(tasks) {
                });
            }
        } else {
            if(task !== 'All') {
                if(lot !== 'All') {
                    var q_call = ProjectTasks.query({ 
                        'project_id': $scope.selectedItem._id,
                        'trade_manager_id': MeanUser.user._id,
                        'complete': false,
                        'lot': $scope.selectedLot.name,
                        'task_code': $scope.selectedTask.name }, function(tasks) {
                    });
                } else if(phase !== 'All') {
                    var q_call = ProjectTasks.query({ 
                        'project_id': $scope.selectedItem._id,
                        'trade_manager_id': MeanUser.user._id,
                        'complete': false,
                        'phase': $scope.selectedPhase.name,
                        'task_code': $scope.selectedTask.name }, function(tasks) {
                    });
                } else {
                    var q_call = ProjectTasks.query({ 
                        'project_id': $scope.selectedItem._id,
                        'trade_manager_id': MeanUser.user._id,
                        'complete': false,
                        'task_code': $scope.selectedTask.name }, function(tasks) {
                    });
                } 
            } else if(lot !== 'All') {
                var q_call = ProjectTasks.query({ 
                    'project_id': $scope.selectedItem._id,
                    'trade_manager_id': MeanUser.user._id,
                    'complete': false,
                    'lot': $scope.selectedLot.name}, function(tasks) {
                });
            } else if(phase !== 'All') {
                var q_call = ProjectTasks.query({ 
                    'project_id': $scope.selectedItem._id,
                    'trade_manager_id': MeanUser.user._id,
                    'complete': false,
                    'phase': $scope.selectedPhase.name}, function(tasks) {
                });
            } else {
                var q_call = ProjectTasks.query({ 
                    'project_id': $scope.selectedItem._id,
                    'complete': false,
                    'trade_manager_id': MeanUser.user._id}, function(tasks) {
                });
            }
        }

        q_call.$promise.then(function(result) {
           $scope.tasks = result;
        });
    };

	$scope.updateForeman = function(task, selectedUser) {
		if(!$scope.selectedItem) {
			alert('Project not selected');
			return;
		}

		if(task.trade !== selectedUser.trade[0]) {
			alert('Selected user ' + selectedUser.name + ' is not a valid selection due to trade.');
			return;
		}

		task.foreman = {
	        name: selectedUser.name,
	        username: selectedUser.username,
	        phone: selectedUser.phone,
	        email: selectedUser.email
    	}

    	task.notes.push({
			date: new Date(),
	        comment: 'Foreman changed to ' + selectedUser.name,
	        username: $scope.user.username
		});

    	task.$update();
	};

	$scope.updateForemanAllTasks = function(selectedUser) {
		if(!$scope.selectedItem) {
			alert('Project not selected');
			return;
		}

        var tasks = [];

        tasks = taskFilterService.getList($scope.tasks,
                    $scope.selectedTrade, $scope.selectedPhase,
                    $scope.selectedLot, $scope.selectedTask);

		tasks.forEach(function(task) {
			if(task.trade === selectedUser.trade[0]) {
				task.foreman = {
			        name: selectedUser.name,
			        username: selectedUser.username,
			        phone: selectedUser.phone,
			        email: selectedUser.email
		    	}

		    	task.notes.push({
					date: new Date(),
			        comment: 'Foreman changed to ' + selectedUser.name,
			        username: $scope.user.username
				});

		    	task.$update();
		    }
	    });

	    this.selectedForeman = '';
	};

	$scope.updateStatus = function(task, status) {
		task.status = status;

		if(status === 'work_stoppage' || status === 'delayed_start') {
			task.hot_sheet = true;
		}

		task.notes.push({
			date: new Date(),
	        comment: 'Status changed to ' + status,
	        username: $scope.user.username
		});

		task.$update();
	};

	$scope.update = function(task) {
		task.$update();
	};

    $scope.editTasks = function() {
        var checked = $filter('filter')($scope.tasks, {'checked': true});
        if($scope.selectionOption === 'status') {
            if($scope.reopen_selected === 'Open') {
                checked.forEach(function(task) {
                    task.status = 'on_track';
                    var note = {
                        date: new Date(),
                        comment: 'Changed the status to on_track to reopen this task',
                        username: $scope.user.username
                    }

                    task.notes.push(note);
                    task.$update();
                });
            } else {
                checked.forEach(function(task) {
                    task.status = 'finished';
                    var note = {
                        date: new Date(),
                        comment: 'Changed the status to finished to close this task',
                        username: $scope.user.username
                    }

                    task.notes.push(note);
                    task.$update();
                });
            }
        } else {
            if(!$scope.entire_schedule || !$scope.change_reason) {
                alert('You must select a Reason option and Entire Schedule option.');
                return;
            }
            if(checked.length === 0) {
                alert('At least one task has to be selected for changes.');
                return;
            }

            var tasks_to_update = [];
            //var q_call = Promise.resolve();

            if($scope.entire_schedule === "No") {
                taskRescheduleService.scheduleNoPush(
                    $scope.user, checked,
                    $scope.new_start_date, $scope.new_end_date, 
                    $scope.change_reason);
            } else {
                //if we are doing the entire schedule then
                //we need to make sure only one task per lot
                //is select or things can get out of whack.
                var items = [];
                for(var i=0; i<checked.length; i++) {
                    var inlist = $filter('filter')(items, {'lot': checked[i].lot}, true);
                    if(inlist.length === 0) {
                        items.push(checked[i])
                    } else {
                        alert('Multiple tasks for the same lot have been selected. \nPlease select one task from a given lot to reschedule the entire task list');
                        return;
                    }
                }
                taskRescheduleService.schedulePush(
                    $scope.user, checked,
                    $scope.new_start_date, $scope.new_end_date, 
                    $scope.change_reason);
            }

            $rootScope.$on('RescheduleEventComplete', function(event, data) {
                data.forEach(function(task) {
                    var update_view = $filter('filter')($scope.tasks, {'_id': task._id}, true)[0];
                    if(!aceUtils.isUndefinedOrNull(update_view)) {
                        update_view.start_date = task.start_date;
                        update_view.end_date = new Date(task.end_date);
                        update_view.days = task.days;
                        update_view.status = task.status;
                        update_view.days_offset = task.days_offset;
                        update_view.checked = false;
                    }
                });
            });
        }
    };

    // This was added just to play around a bit
    // taskService.getByTrade($scope.user.trade[0]).then(function (response) {
    //         $scope.returned_tasks = response;
    //     }, function (error) {
    //         console.error(error);
    // });

    // $scope.clickToUpdate = function(task) {
    //     taskService.update(task).then(function(response) {
    //         task = response;
    //     }, function(error) {
    //         console.error(error);
    //     });
    // };

    $scope.startDateChanged = function(new_start_date) {
        var date = moment(new_start_date).add(8, 'hours').add(30, 'minutes');
        $scope.new_end_date = new Date(date);
    };

    $scope.taskChecked = function(task) {
        if(task.checked) {
            var start = moment(task.start_date);
            var end = moment(task.end_date);

            $scope.new_start_date = new Date(start);
            $scope.new_end_date = new Date(end);
        } else {
            $scope.new_start_date = '';
            $scope.new_end_date = '';
        }
    };
}]);



// WEBPACK FOOTER //
// ./packages/custom/projects/public/controllers/projectTasksAdmin.js